<template>
    <div>
        <modal name="restaurant-map"
               width="90%"
               height="80vh"
               @before-open="modalOpened"
               classes="bg-white rounded-none shadow-inner">
            <h1 class="map-modal-title text-center">{{ company_details.name }}, {{ company_details.city }}</h1>
            <ul class="landing-links">
                <li v-for="(landingLink, title) in mapLandings">
                    <a :href="landingLink" target="_blank">{{ title }}</a>
                </li>
            </ul>
            <span @click="showAddressInput" :title="translations.get_directions"
                  class="lnr lnr-location navigation-btn"></span>
            <div v-show="displayAddressInput" class="address-input">
                <div @click="hideAddressInput" class="close-address-input"><strong>X</strong></div>
                <input type="text" v-model="userAddressInput" :placeholder="translations.enter_address">
                <button @click="handleGetDirections" class="btn btn-primary">{{ translations.get_directions }}</button>
            </div>
            <div id="mapdiv" style="width: 100%; height:80vh; position: relative; overflow: visible; padding: 15px;">
                <iframe
                    style="border: 0;"
                    loading="lazy"
                    allowfullscreen
                    :src="googleMapsUrl">
                </iframe>
                <button class="button-x" @click="$modal.hide('restaurant-map')"><strong>X</strong></button>
            </div>
        </modal>
    </div>
</template>

<script>
import mixins from "../mixins";

export default {
    mixins: [
        mixins
    ],
    props: {
        details: {
            type: String,
            required: true
        },
        api_key: {
            type: String,
            required: true
        },
        map_landings_str: {
            type: String,
            required: false
        },
        translations_str: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            company_details: {},
            mapLandings: {},
            translations: {},
            displayAddressInput: false,
            userAddressInput: '',
            baseGoogleMapsUrl: 'https://www.google.com/maps/embed/v1/place',
            queryGoogleMapsUrl: '?key=' + this.api_key,
        }
    },
    computed: {
        googleMapsUrl: function () {
            return this.baseGoogleMapsUrl + this.queryGoogleMapsUrl;
        }
    },
    methods: {
        async modalOpened() {
            this.initMap('google', 30);
        },
        showAddressInput() {
            this.displayAddressInput = true;
        },
        hideAddressInput() {
            this.displayAddressInput = false;
        },
        handleGetDirections: function () {
            let address = this.userAddressInput;
            address = address.trim();

            if (address === '') {
                this.baseGoogleMapsUrl = 'https://www.google.com/maps/embed/v1/place';
                this.queryGoogleMapsUrl = '?key=' + this.api_key + '&q=' + this.company_details.address + '&center=' +
                    this.company_details.lat + ',' + this.company_details.lng + '&zoom=17';

                return;
            }

            this.baseGoogleMapsUrl = 'https://www.google.com/maps/embed/v1/directions';
            this.queryGoogleMapsUrl = '?key=' + this.api_key + '&origin=' + address + '&destination=' +
                this.company_details.address;
        },
    },
    mounted() {
        this.company_details = JSON.parse(this.details);
        this.mapLandings = JSON.parse(this.map_landings_str);
        this.translations = JSON.parse(this.translations_str);

        this.queryGoogleMapsUrl = '?key=' + this.api_key + '&q=' + this.company_details.address + '&center=' +
            this.company_details.lat + ',' + this.company_details.lng + '&zoom=17';
    }
}
</script>

<style>
.map-modal-title {
    margin-top: 10px;
    margin-bottom: -10px;
}

.landing-links {
    position: absolute;
    bottom: 120px;
    left: -15px;
    list-style-type: none;
}

.landing-links li {
    position: relative;
    margin-bottom: 5px;
    background: white;
    z-index: 20;
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.35);
    border-radius: 10px;
    padding: 10px 20px;
}

.landing-links li a {
    color: #363636;
}

.navigation-btn {
    position: absolute;
    bottom: 130px;
    right: 25px;
    background: white;
    z-index: 20;
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.35);
    border-radius: 50%;
    padding: 15px;
    font-size: 28px;
    cursor: pointer;
    color: #7F9741;
}

.address-input {
    position: absolute;
    right: 25px;
    bottom: 130px;
    z-index: 90;
    background: white;
    padding: 20px;
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.35);
}

.address-input input[type="text"] {
    padding: 10px 5px;
}

.close-address-input {
    position: absolute;
    top: -14px;
    right: -14px;
    background: #7F9741;
    color: white;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    text-align: center;
    cursor: pointer;
    font-size: 20px;
    line-height: 1.5;
    z-index: 99;
}

.button-x {
    right: 2px;
    position: absolute;
    top: 2px;
    z-index: 99;
    font-size: 19px;
    background-color: #7F9741;
    padding: 0 8px;
    cursor: pointer;
    border-radius: 50%;
    line-height: 1.5;
    color: #fff;
}

.H_ib_content {
    width: 300px;
    font-size: 12px;
    margin: 0;
    padding: 2px 10px;
}

.H_ib_body {
    margin-right: -17em;
    margin-bottom: 68px;
}

.H_ib_tail::after {
    bottom: 63px;
}

.H_ib_tail::before {
    bottom: 63px;
}

.v--modal-overlay {
    padding-top: 100px;
}

@media (max-height: 700px) {
    .v--modal-overlay {
        padding-top: 50px;
    }
}

@media (max-height: 450px) {
    .v--modal-overlay {
        padding-top: 25px;
    }
}

@media (max-width: 700px) {
    .landing-links {
        display: none;
    }
}

@media (max-width: 450px) {
    .address-input {
        display: flex;
        flex-direction: column;
    }

    .address-input input[type="text"] {
        margin-bottom: 10px;
    }
}

@media (min-width: 320px) and (max-width: 480px) {
    .H_ib_content {
        width: 200px !important;
    }

    .H_ib_body {
        margin-right: -12em !important;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/RestaurantMap.vue